var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.posts.nodes.length)?_c(_setup.PublicPortfolioPostsListSection,{attrs:{"initial-posts":_vm.posts.nodes}}):_c(_setup.PublicPortfolioPostsEmptySection)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }